import { render } from "./PlaylistTable.vue?vue&type=template&id=6c352831"
import script from "./PlaylistTable.vue?vue&type=script&lang=js"
export * from "./PlaylistTable.vue?vue&type=script&lang=js"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__